import { DropdownOptionType } from "../types";

export const PercentageData: DropdownOptionType[] = [
  {
    id: 40,
    text: "< 40%",
  },
  {
    id: 44.9,
    text: "40%-44.9%",
  },
  {
    id: 49.9,
    text: "45%-49.9%",
  },
  {
    id: 54.9,
    text: "50%-54.9%",
  },
  {
    id: 59.9,
    text: "55%-59.9%",
  },
  {
    id: 64.9,
    text: "60%-64.9%",
  },
  {
    id: 69.9,
    text: "65%-69.9%",
  },
  {
    id: 74.9,
    text: "70%-74.9%",
  },
  {
    id: 79.9,
    text: "75%-79.9%",
  },
  {
    id: 84.9,
    text: "80%-84.9%",
  },
  {
    id: 89.9,
    text: "85%-89.9%",
  },
  {
    id: 94.9,
    text: "90%-94.9%",
  },
  {
    id: 99.9,
    text: "95%-99.9%",
  },
  {
    id: 100,
    text: "100%",
  },
];

export const YearsData: DropdownOptionType[] = [
  { id: 1, text: "2028" },
  { id: 2, text: "2027" },
  { id: 3, text: "2026" },
  { id: 4, text: "2025" },
  { id: 5, text: "2024" },
  { id: 6, text: "2023" },
  { id: 7, text: "2022" },
  { id: 8, text: "2021" },
  { id: 9, text: "2020" },
  { id: 10, text: "2019" },
  { id: 11, text: "2018" },
  { id: 12, text: "2017" },
  { id: 13, text: "2016" },
  { id: 14, text: "2015" },
  { id: 15, text: "2014" },
  { id: 16, text: "2013" },
  { id: 17, text: "2012" },
  { id: 18, text: "2011" },
  { id: 19, text: "2010" },
  { id: 20, text: "2009" },
  { id: 21, text: "2008" },
  { id: 22, text: "2007" },
  { id: 23, text: "2006" },
  { id: 24, text: "2005" },
  { id: 25, text: "2004" },
  { id: 26, text: "2003" },
  { id: 27, text: "2002" },
  { id: 28, text: "2001" },
  { id: 29, text: "2000" },
  { id: 30, text: "1999" },
  { id: 31, text: "1998" },
  { id: 32, text: "1997" },
  { id: 33, text: "1996" },
  { id: 34, text: "1995" },
  { id: 35, text: "1994" },
  { id: 36, text: "1993" },
  { id: 37, text: "1992" },
  { id: 38, text: "1991" },
  { id: 39, text: "1990" },
  { id: 40, text: "1989" },
  { id: 41, text: "1988" },
  { id: 42, text: "1987" },
  { id: 43, text: "1986" },
  { id: 44, text: "1985" },
  { id: 45, text: "1984" },
  { id: 46, text: "1983" },
  { id: 47, text: "1982" },
  { id: 48, text: "1981" },
  { id: 49, text: "1980" },
  { id: 50, text: "1979" },
  { id: 51, text: "1978" },
  { id: 52, text: "1977" },
  { id: 53, text: "1976" },
  { id: 54, text: "1975" },
  { id: 55, text: "1974" },
  { id: 56, text: "1973" },
  { id: 57, text: "1972" },
  { id: 58, text: "1971" },
  { id: 59, text: "1970" },
  { id: 60, text: "1969" },
  { id: 61, text: "1968" },
  { id: 62, text: "1967" },
  { id: 63, text: "1966" },
  { id: 64, text: "1965" },
  { id: 65, text: "1964" },
  { id: 66, text: "1963" },
  { id: 67, text: "1962" },
  { id: 68, text: "1961" },
  { id: 69, text: "1960" },
  { id: 70, text: "1959" },
  { id: 71, text: "1958" },
  { id: 72, text: "1957" },
  { id: 73, text: "1956" },
  { id: 74, text: "1955" },
  { id: 75, text: "1954" },
  { id: 76, text: "1953" },
  { id: 77, text: "1952" },
  { id: 78, text: "1951" },
  { id: 79, text: "1950" },
  { id: 80, text: "1949" },
  { id: 81, text: "1948" },
  { id: 82, text: "1947" },
  { id: 83, text: "1946" },
  { id: 84, text: "1945" },
  { id: 85, text: "1944" },
  { id: 86, text: "1943" },
  { id: 87, text: "1942" },
  { id: 88, text: "1941" },
  { id: 89, text: "1940" },
];
